export const APP_ROUTE = {
	BASE: '/',
	PRODUCT_GROUP: (groupID = ":groupID") => `/group/${groupID}`,
	CONFIGURATOR: (groupID = ":groupID", productID = ":productID/:categoryID?") => `${APP_ROUTE.PRODUCT_GROUP(groupID)}/configure/${productID}`,
	CONFIGURATOR_SUMMARY: (groupID = ":groupID", productID = ":productID") => `${APP_ROUTE.CONFIGURATOR(groupID, productID)}/summary`,
	CONFIGURATOR_CATEGORY: (groupID = ":groupID", productID = ":productID", categoryID = ":categoryID") => `${APP_ROUTE.CONFIGURATOR(groupID, productID)}/${categoryID}`,
};
